//src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/auth/Login';
import Signup from './pages/auth/Signup';
import Dashboard from './pages/dashboard/Dashboard';
import CreateAgent from './pages/agents/CreateAgent';
import EditAgent from './pages/agents/EditAgent';
import AgentStats from './pages/agents/AgentStats';
import PricingPage from './pages/pricing/PricingPage';
import DashboardLayout from './components/layout/DashboardLayout';
import { AuthProvider, useAuth } from './context/AuthContext';
import LandingPage from './pages/landing/LandingPage';
import PrivacyPolicy from './pages/landing/PrivacyPolicy';
import Terms from './pages/landing/Terms';
import './App.css';

// Import ProtectedRoute from common components
import ProtectedRoute from './components/common/ProtectedRoute';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />

          {/* Public Auth Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />

          {/* Protected Routes */}
          <Route 
            path="/pricing" 
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<PricingPage />} />
          </Route>
          
          {/* Protected routes with DashboardLayout */}
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            {/* Nested routes that will render in the DashboardLayout outlet */}
            <Route index element={<Dashboard />} />
            <Route path="create-agent" element={<CreateAgent />} />
            <Route path="edit-agent/:agentId" element={<EditAgent />} />
            <Route path="agent-stats/:agentId" element={<AgentStats />} />
            <Route path="pricing" element={<PricingPage />} />
            <Route path="conversation/:sessionId" element={<Dashboard />} />
          </Route>
          
          {/* Redirect root to dashboard if authenticated, otherwise to login */}
          <Route 
            path="/" 
            element={<AuthRedirect />} 
          />
          
          {/* Fallback for any other routes */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

// Component to redirect based on authentication status
const AuthRedirect = () => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return <div className="loading-screen">Loading...</div>;
  }
  
  if (isAuthenticated) {
    return <Navigate to="/dashboard" />;
  }
  
  return <Navigate to="/login" />;
};

export default App;
